import { render, staticRenderFns } from "./Asientos.vue?vue&type=template&id=f29942f0&scoped=true&"
import script from "./Asientos.vue?vue&type=script&lang=js&"
export * from "./Asientos.vue?vue&type=script&lang=js&"
import style0 from "./Asientos.vue?vue&type=style&index=0&id=f29942f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29942f0",
  null
  
)

export default component.exports